'use strict';
var UA = require('../internals/engine-user-agent');

module.exports = /MSIE|Trident/.test(UA);



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/engine-is-ie-or-edge.js
// module id = 1191
// module chunks = 0